import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import * as stylex from "@stylexjs/stylex";
export default function CenteredColumnWidth(props) {
  var _props$width;
  var style = {
    width: "".concat((_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 500, "px")
  };
  if (props.style) {
    style = _objectSpread(_objectSpread({}, style), props.style);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.base, props.containerStylex), {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "ui-center-div"
  }, props.children));
}

// @ts-ignore
_inject("@media (max-width: 599px){.ev1i0qtz1.ev1i0qtz1{width:100%}}", 4200);
_inject("@media (max-width: 599px){.ev1l060o2.ev1l060o2{padding:25px}}", 1200);
var ui = {
  base: {
    "CenteredColumnWidth__ui.base": "CenteredColumnWidth__ui.base",
    "@media (max-width: 599px)_width": "ev1i0qtz1",
    "@media (max-width: 599px)_padding": "ev1l060o2",
    "@media (max-width: 599px)_paddingInline": null,
    "@media (max-width: 599px)_paddingStart": null,
    "@media (max-width: 599px)_paddingLeft": null,
    "@media (max-width: 599px)_paddingEnd": null,
    "@media (max-width: 599px)_paddingRight": null,
    "@media (max-width: 599px)_paddingBlock": null,
    "@media (max-width: 599px)_paddingTop": null,
    "@media (max-width: 599px)_paddingBottom": null,
    $$css: true
  }
};